import { render, staticRenderFns } from "./TestVideoRecordingInfo.vue?vue&type=template&id=1f33113c&scoped=true&"
import script from "./TestVideoRecordingInfo.vue?vue&type=script&lang=js&"
export * from "./TestVideoRecordingInfo.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoRecordingInfo.vue?vue&type=style&index=0&id=1f33113c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33113c",
  null
  
)

export default component.exports